import { render } from "./BookmarkWidget.vue?vue&type=template&id=c4e4326c"
import script from "./BookmarkWidget.vue?vue&type=script&lang=js"
export * from "./BookmarkWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__